import React, { Component } from 'react'
// images
const doorstep = require('../../images/door-setp.svg');

interface IProps {
  statusHandler: any;
  language: string;
  multiLang: any;
  languageCode: string;
  handleLanguageChange: any;
}

export class DoorStepComponent extends Component<IProps> {
  componentDidMount() {
    // Call statusHandler with argument 2 when the component mounts
    if (this.props.statusHandler) {
      this.props.statusHandler(1);
    }
  }
  render() {
    const { language, multiLang } = this.props;
    return (
      <>
        <div className='preStep'>
          <img src={doorstep} style={{ marginTop: '32px' }} alt='door step image' />
          <div className='preStep__title'>
            <h2>{multiLang[`doorStepTitle${language}`]}</h2>
          </div>
          <div className='preStep__panel'>
            <div className='preStep__header'>
              <h2>{multiLang[`doorStepPanelTitle${language}`]}</h2>
            </div>
            <div className='preStep__body'>
              <p>{multiLang[`doorStepPanelText1${language}`]}</p>
              <p>{multiLang[`doorStepPanelText2${language}`]}</p>
              <div className='grayBox'>
                <p>{multiLang[`doorStepPanelMessage${language}`]}</p>
              </div>
              {/* <div className='preStep__footer'>
                  <button className='btn btn__purple' onClick={() => this.props.statusHandler(2)}>{multiLang[`doorStepPanelButton${language}`]}</button>
              </div> */}
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default DoorStepComponent;



// WEBPACK FOOTER //
// ./src/components/doorstep/doorstep.component.tsx